export default __webpack_public_path__ + "static/media/ubuntu.ebaca27f.svg";